module.exports = __webpack_public_path__ + "assets/img/images_e.08d76e5c.png";